import React from 'react';

import { useDispatch } from 'react-redux';

import Button from '@amzn/meridian/button';
import Row from '@amzn/meridian/row';
import SearchField from '@amzn/meridian/search-field';
import ToggleFilterButton from 'src/components/shared/toggleFilterButton/toggleFilterButton';
import { setIsAdvancedFilterSheetOpen } from 'src/store/adminConfigPageSlice/siteConfigPageSlice/siteConfigPageSlice';
import {
  setIsCreateModalOpen,
  setSearchField,
} from 'src/store/adminConfigPageSlice/siteConfigPageSlice/siteConfigPageSlice';
import { useAppSelector } from 'src/store/store';

const TopOptions = () => {
  const dispatch = useDispatch();
  const { searchField } = useAppSelector((state) => state.siteConfigPage);
  return (
    <Row widths={['85%', '15%']} spacingInset="400 none" alignmentHorizontal="justify">
      <Row width={'grid-4'}>
        <SearchField
          value={searchField}
          onChange={(newSearchField) => dispatch(setSearchField(newSearchField))}
          placeholder="Search for..."
          onSubmit={() => {}}
          data-cy="site-input-search"
        />
        <ToggleFilterButton
          aria-label="Filter Sites"
          data-testid="site-configuration__filter-sheet-btn"
          tooltipTitle="Open Site Configuration Filter"
          onClick={() => dispatch(setIsAdvancedFilterSheetOpen(true))}
        />
      </Row>

      <Button id="site-config-top-options-open-modal" onClick={() => dispatch(setIsCreateModalOpen(true))}>
        Add New Site
      </Button>
    </Row>
  );
};

export default TopOptions;
